import { render, staticRenderFns } from "./SubcategoryPage.vue?vue&type=template&id=4e0b73d1&scoped=true"
import script from "./SubcategoryPage.vue?vue&type=script&lang=js"
export * from "./SubcategoryPage.vue?vue&type=script&lang=js"
import style0 from "./SubcategoryPage.vue?vue&type=style&index=0&id=4e0b73d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0b73d1",
  null
  
)

export default component.exports